import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Technology from './components/Technology';
import Features from './components/Features';
import History from './components/History';
import Awards from './components/Awards';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DealerButton from './components/DealerButton';
import ScrollToTop from './components/ScrollToTop';

// Lazy load components for better performance
const PassengerVehicles = lazy(() => import('./components/PassengerVehicles'));
const LoaderVehicles = lazy(() => import('./components/LoaderVehicles'));
const Mission = lazy(() => import('./components/Mission'));
const Blog = lazy(() => import('./components/Blog'));
const AdminPanel = lazy(() => import('./components/Admin/AdminPanel'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#CC0000]"></div>
  </div>
);

function HomePage() {
  return (
    <>
      <Hero />
      <Technology />
      <Features />
      <History />
      <Awards />
      <Team />
      <Suspense fallback={<div className="h-32 flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#CC0000]"></div></div>}>
        <Blog />
      </Suspense>
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Routes>
          {/* Admin Route - No header/footer */}
          <Route path="/admin" element={
            <Suspense fallback={<LoadingSpinner />}>
              <AdminPanel />
            </Suspense>
          } />
          
          {/* Public Routes - With header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/passenger-vehicles" element={
                    <Suspense fallback={<LoadingSpinner />}>
                      <PassengerVehicles />
                    </Suspense>
                  } />
                  <Route path="/loader-vehicles" element={
                    <Suspense fallback={<LoadingSpinner />}>
                      <LoaderVehicles />
                    </Suspense>
                  } />
                  <Route path="/mission" element={
                    <Suspense fallback={<LoadingSpinner />}>
                      <Mission />
                    </Suspense>
                  } />
                </Routes>
              </main>
              <Footer />
              <DealerButton />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;